/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeIncidentPriorityBodyPriorityMax = 4;

export const changeIncidentPriorityBodyExpectedVersionExclusiveMin = 0;
export const changeIncidentPriorityBodyExpectedVersionMax = 9007199254740991;

export const ChangeIncidentPriorityBody = zod.object({
  priority: zod.int().min(1).max(changeIncidentPriorityBodyPriorityMax),
  expectedVersion: zod
    .int()
    .gt(changeIncidentPriorityBodyExpectedVersionExclusiveMin)
    .max(changeIncidentPriorityBodyExpectedVersionMax),
});

export type ChangeIncidentPriorityBody = zod.input<typeof ChangeIncidentPriorityBody>;
export type ChangeIncidentPriorityBodyOutput = zod.output<typeof ChangeIncidentPriorityBody>;
